import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
import { toLower } from 'lodash';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EventManager } from 'app/shared/util/event-manager.service';
import { AccountService } from "app/shared";



@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private eventManager: EventManager,
    private injector: Injector
  ) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const shouldRedirect = !(toLower(request.url).endsWith('/api/account') && toLower(request.method) === 'get') && !toLower(request.url).endsWith('/oauth/token');

        if (err.status === 401) {
          if ((request.url.endsWith("/api/account") && request.method == "POST") || request.url.endsWith("/account/change_password")) {
              const result = {"email": request.body.username}
              this.router.navigateByUrl('/auth/deactivated', {
                  state: result
              });
              return of(null);
          }
          if (request.url.endsWith('/oauth/token')) {
            this.router.navigateByUrl('/auth/deactivated', {
              state: {
                email: decodeURIComponent(request.body.map.get('username'))
              }
            });
            return of(null);
          }
          if (shouldRedirect) {
            this.injector.get(AccountService).authenticate(null);
            this.router.navigateByUrl('/auth/sign-in');
          }
          return of(null);
        }
        if (err.status === 403) {
          this.router.navigateByUrl('/accessdenied');
          return of(null);
        }
        if (err.status === 409 && request.method === 'DELETE') {
          // don't report error about this.
          return of(null);
        }
        this.eventManager.broadcast({
          name: 'managementPortalApp.httpError',
          content: err
        });

        return throwError(err);
      })
    );
  }
}
